import React, { createContext, useState } from 'react'; 

export const CurrentContext = createContext();

export default function CurrentProvider(props) {

    const [current, setCurrent] = useState({})

    return(
        <CurrentContext.Provider value={[current, setCurrent]}>
            {props.children}
        </CurrentContext.Provider>
    )
}